var Menu = /** @class */ (function () {
    function Menu() {
    }
    Menu.prototype.init = function () {
        var $ = jQuery;
        $('#ac_list_screen').on('change', function () {
            $('.view-link').hide();
            $(this).parents('form').submit();
            $(this).prop('disabled', true).next('.spinner').css('display', 'inline-block');
        });
    };
    return Menu;
}());
export default Menu;
